import {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { Row, Col } from 'reactstrap';

import CustomModal, { ICustomModal } from '@shared/components/modal/CustomModal';
import {
  VIllustrationIcon,
} from '@shared/icons';

import VerificationContent from './modal-contents/VerificationContent';
import VerifiedContent from './modal-contents/VerifiedContent';
import VerifyCodeContent from './modal-contents/VerifyCodeContent';

import './VerificationModalStyle.scss';

const VerificationModal = (props: ICustomModal) => {
  const { open, toggle, type } = props;
  const [ step, setStep ] = useState(0);
  const handleNextScreen = useCallback(() => setStep(prev => (
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    prev + 1 > content.length - 1 ? content.length - 1 : prev + 1)),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [ ]);
  const handlePrevScreen = useCallback(() => setStep(prev => (prev - 1 < 0 ? 0 : prev - 1)), [ ]);

  const content: Array<Omit<ICustomModal, 'modalProps' | 'open' | 'toggle'> & { type?: string }> = useMemo(() => (
    [
      {
        children: <VerificationContent onNext={handleNextScreen} onToggle={toggle} type={type} />,
        noHeader: true,
        noFooter: true,
      },
      {
        children: <VerifyCodeContent
          onNext={handleNextScreen}
          onBack={handlePrevScreen}
          onToggle={toggle}
          type={type}
        />,
        noHeader: true,
        noFooter: true,
      },
      {
        children: <VerifiedContent onToggle={toggle} type={type} />,
        noHeader: true,
        noFooter: true,
      },
    ]
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [ handleNextScreen, handlePrevScreen, type ]);

  useEffect(() => () => {
    // reset step if succeeded
    if (open && step === content.length - 1) setStep(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ open, step ]);

  return (
    <CustomModal
      {...props}
      noHeader={content[step].noHeader}
      noFooter={content[step].noFooter}
      modalProps={{ centered: true, id: 'verification-modal', className: 'modal-lg' }}
      content={content[step].content}
    >
      <Row>
        <Col lg={6}>
          <VIllustrationIcon />
        </Col>
        <Col lg={6}>
          {content[step] && content[step].children ? content[step].children : null}
        </Col>
      </Row>
    </CustomModal>
  );
};

export default VerificationModal;
